module.exports = __webpack_public_path__ + "img/success-banner-v2.60516aa9.svg";